import { useParams } from 'react-router-dom';

export function useRouteParams<T extends Record<string, string>>() {
  const params = useParams<T>() as Required<T>;
  return params;
}
